<template>
  <div class="bottom">
    <div class="btm-panel">
      <div class="intro">
        <img class="logo" src="/static/image/logo_foot@2x.png" />
        <div class="tag-panel">
          <div class="tag">
            <div class="item">南京晨新医疗科技有限公司</div>
            <div class="item a">
              地址：南京市鼓楼区清江南路18号鼓楼创新广场D栋18层
            </div>
            <div class="item a">电话：400-1331-551</div>

            <div class="em">
              <div class="item a ema">
                邮箱：
              </div>
              <div class="ea">
                <div class="item a">商务合作 business@cnewmedical.com</div>
                <div class="item a">简历投递 hr@cnewmedical.com</div>
              </div>

            </div>

          </div>
          <div class="logo-foot">
            <!-- <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao@2x.png" />
              <div class="label">关注晨新医疗公众号</div>
            </div>
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao2.png" />
              <div class="label">关注晨新致远公众号</div>
            </div>
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao_peizhenhui.png" />
              <div class="label">关注陪诊汇公众号</div>
            </div> -->
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao@2x.png" />
              <div class="label">关注晨新医疗公众号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="copy">
        <div class="value">
          版权所有 © 2022 晨新医疗 cnewmedical 苏ICP备2023047460号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      localIndex: -1,
      activedMenu: 0,
      navs: {
        aboutNavs: {
          title: "关于晨新",
          subTitle: [
            {
              title: "关于晨新",
              path: "aboutCnew",
              selectedNuber: 0
            },
            {
              title: "发展历程",
              path: "hostory",
              selectedNuber: 1
            },
            // {
            //   title: "资质荣誉",
            //   path: "honour",
            //   selectedNuber:2
            // },
          ],
        },
        hxjsNavs: {
          title: "核心技术",
          subTitle: [
            {
              title: "核心技术",
              path: "coreTechnology",
              selectedNuber: 0
            },
            {
              title: "5 Key 优势",
              path: "5Key",
              selectedNuber: 1
            },
            {
              title: "自研ISP算法",
              path: "algorithm",
              selectedNuber: 2
            },
          ],
        },
        cpzxNavs: {
          title: "产品中心",
          subTitle: [
            {
              title: "内窥镜摄像系统解决方案",
              path: "programme",
              selectedNuber: 0
            },
            {
              title: "智能数字化手术室",
              path: "operatingRoom",
              selectedNuber: 1
            }
          ],
        },
        newsNavs: {
          title: "新闻中心",
          subTitle: [
            {
              title: "新闻中心",
              path: "news",
            }
          ],
        },
        supportNavs: {
          title: "服务支持",
          subTitle: [
            {
              title: "服务支持",
              path: "support",
              selectedNuber: 0
            }
          ],
        },
        joinusNavs: {
          title: "加入我们",
          subTitle: [
            {
              title: "职位探索",
              path: "position",
              selectedNuber: 0
            },
            {
              title: "福利待遇",
              path: "welfare",
              selectedNuber: 1
            },
            // {
            //   title: "办公环境",
            //   path: "environment",
            //   selectedNuber:2
            // },
            {
              title: "联系我们",
              path: "contactUs",
              selectedNuber: 2
            },
          ],
        },
      },
    };
  },
  created() { },
  mounted() { },
  methods: {
    pushView(item, type) {
      window.localStorage.setItem('index', type);
      this.$router.push({
        name: item.path, params: {
          selectedNuber: item.selectedNuber
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  height: 710px;
  width: 100%;
  // position: absolute;
  bottom: 0px;
  margin-top: 50px;
  // background: #EFEFEF;
  background: linear-gradient(180deg, #186DD5 0%, #0549A2 100%);
  // fontcolor white
  border-radius: 0px 0px 0px 0px;

  .btm-panel {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 1px);
    position: relative;

    .intro {
      width: 100%;
      display: flex;
      box-sizing: border-box;
      padding: 32px 43px 0px 43px;
      flex-direction: column;
      position: relative;
      align-items: center;

      .logo {
        width: 160px;
        // margin-bottom: 24px;
        height: 70px;
      }

      .tag-panel {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        .tag {
          width: 100%;
          display: flex;
          align-self: flex-start;
          flex-direction: column;

          .item {
            cursor: pointer;
            width: 100%;
            text-align: left;
            font-size: 30px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            // color: #333333;
            color: #ffffff;
            margin-bottom: 8px;
          }

          .em {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .ema {
              width: 85px;
            }

          }

          .a {
            font-size: 28px;
            font-weight: 400;
          }

        }

        .c5 {
          // width: 301px;
        }

        .logo-foot {
          display: flex;
          flex-direction: row;

          // width: 126px;
          // align-items: center;
          .logo-foot_c {

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              width: 160px;
              height: 160px;
              margin-bottom: 8px;
              margin-top: 50px;
            }

            .label {
              width: 230px;
              height: 19px;
              text-align: center;
              font-size: 24px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              // color: #333333;
              color: #ffffff;
            }
          }


        }
      }
    }

    .copy {
      display: flex;
      width: 100%;
      position: absolute;
      margin-top: 46px;
      line-height: 36px;
      height: 22px;
      bottom: 8px;
      justify-content: center;
      align-items: center;

      .value {
        font-size: 22px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        // color: #333333;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue